import { render } from "./Stock.vue?vue&type=template&id=61465505"
import script from "./Stock.vue?vue&type=script&lang=js"
export * from "./Stock.vue?vue&type=script&lang=js"

import "./Stock.vue?vue&type=style&index=0&id=61465505&lang=css"
import "./Stock.vue?vue&type=style&index=1&id=61465505&lang=css"
script.render = render

export default script